<template>
    <div class="modal fade" tabindex="-1" :id="id">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <form @submit.prevent="submitForm" class="form">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ !isEdit ? $t('user.create') : $t('user.edit') }}</h5>
              <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
                <span class="svg-icon svg-icon-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                        fill="currentColor"/>
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                        fill="currentColor"/>
                </svg>
              </span>
              </div>
            </div>
            <div class="modal-body scroll-y" style="max-height: 75vh;">
              <RequiredText />
              <div class="row">
                <div class="col-12 col-md-6 col-lg-6">
                  <Select2
                      :parent-id="'#'+id"
                      containerClass="col-12 mt-auto mb-5"
                      :name="`${id}-gender`"
                      type="text"
                      :label="$t('user.gender')"
                      labelClass="form-label fs-6 text-black"
                      selectClass="form-select form-select-solid"
                      :isRequired="true" size="lg"
                      :placeholder="$t('user.civility')"
                      v-model="formData.gender"
                      :multiple="false">
                    <option value="female">{{ $t('user.female') }}</option>$
                    <option value="male">{{ $t('user.male') }}</option>
                  </Select2>
                  <Input
                      containerClass="col-12 mt-auto mb-5"
                      :name="`${id}-lastname`"
                      type="text"
                      :label="$t('user.lastname')"
                      labelClass="form-label fs-6 text-black"
                      :inputClass="'form-control form-control-lg form-control-solid'"
                      :isRequired="true" size="lg"
                      :placeholder="$t('user.lastname_placeholder')"
                      v-model="formData.lastname"
                  />
                </div>
                <div class="col-12 col-md-6 col-lg-6 d-flex justify-content-center">
                  <ImageInput v-model:image="formData.avatar" :model-image="formData.avatar_url" containerClass="mb-10 text-center" />
                </div>
                <div class="row">
                  <Input
                      containerClass="col-12 col-md-6 mt-auto mb-5"
                      :name="`${id}-firstname`"
                      type="text"
                      :label="$t('user.firstname')"
                      labelClass="form-label fs-6 text-black"
                      :inputClass="'form-control form-control-lg form-control-solid'"
                      :isRequired="true" size="lg"
                      :placeholder="$t('user.firstname_placeholder')"
                      v-model="formData.firstname"
                  />
                  <Input
                      containerClass="col-12 col-md-6 mt-auto mb-5"
                      :name="`${id}-initial`"
                      type="text"
                      :label="$t('user.initial')"
                      labelClass="form-label fs-6 text-black"
                      :inputClass="'form-control form-control-lg form-control-solid'"
                      :isRequired="false" size="lg"
                      :placeholder="$t('user.initial_placeholder')"
                      v-model="formData.initials"
                  />
                </div>
                <Input
                    containerClass="col-12 col-md-6 mt-auto mb-5"
                    :name="`${id}-email`"
                    type="email"
                    :label="$t('user.email')"
                    labelClass="form-label fs-6 text-black"
                    :inputClass="'form-control form-control-lg form-control-solid'"
                    :isRequired="true" size="lg"
                    :placeholder="$t('user.email_placeholder')"
                    v-model="formData.email"
                />
                <InputTel
                    :name="`${id}-phone`"
                    type="text"
                    :label="$t('user.phone')"
                    containerClass="col-md-6 mb-5"
                    labelClass="form-label fs-6 text-black"
                    inputClass="form-control form-control-sm form-control-solid"
                    v-model:phone="formData.phone"
                    v-model:phone-code="formData.phone_code"
                    :placeholder="$t('enter_phone')"
                    :isRequired="true" />
              </div>
              <div class="row">
                <Select2
                    :parent-id="'#'+id"
                    container-class="form-group col-6 mt-auto mb-5"
                    :multiple="false"
                    :show-search="true"
                    :selectClass="'form-select form-control-lg form-select-solid'"
                    :name="`${id}-society`"
                    :label="$t('user.society')"
                    labelClass="form-label fs-6 text-black"
                    v-model="formData.society_id"
                    :IsInputGroup="false">
                  <option value="">{{ $t('user.society_placeholder') }}</option>
                  <option v-for="society in societiesOffices" :key="society.id" :value="society.id">
                    {{ society.name }}
                  </option>
                </Select2>

                <Select2
                    :parent-id="'#'+id"
                    container-class="form-group col-6 mt-auto mb-5"
                    :multiple="false"
                    :show-search="true"
                    :selectClass="'form-select form-control-lg form-select-solid'"
                    :name="`${id}-office`"
                    :label="$t('user.office')"
                    labelClass="form-label fs-6 text-black"
                    v-model="formData.office_id"
                    :IsInputGroup="false"
                   >
                  <option value="">{{ $t('user.office_placeholder') }}</option>
                  <option v-for="office in offices" :key="office.id" :value="office.id">
                    {{ office.name }}
                  </option>
                </Select2>

              </div>

              <div class="row">
                <Select2
                    :parent-id="'#'+id"
                    container-class="form-group col-12 col-md-6 mt-auto mb-5"
                    :multiple="false"
                    :show-search="true"
                    :selectClass="'form-select form-control-lg form-select-solid'"
                    :name="`${id}-rights`"
                    :label="$t('user.right')"
                    labelClass="form-label fs-6 text-black"
                    v-model="formData.role"
                    :IsInputGroup="true"
                    icon="bi bi-plus"
                    :clickAddon="openCreateRightModal">
                  <option value="">{{ $t('user.role_placeholder') }}</option>
                  <option v-for="role in roles" :key="id+role.id" :value="role.id">
                    {{ role.name }}
                  </option>
                </Select2>

                <div class="col-6 my-auto">
                  <div class="form-check form-check-custom form-check-solid">
                    <input class="form-check-input" type="checkbox" id="flexCheckChecked"
                           v-model="formData.active"
                           checked="checked" />
                    <label class="form-check-label" for="flexCheckChecked">{{ $t('user.is_active_text') }}</label>
                  </div>
                </div>
              </div>

              <div v-if="!isEdit" class="row">
                <div :style="{'background-color': $getCssVariable('--bs-light-primary')}" class="alert alert-dismissible d-flex flex-column flex-sm-row p-5 mb-10 mt-6">
                  <div class="d-flex flex-column pe-0 pe-sm-10 mt-3">
                    <span> {{$t('user.alert_password')}}</span>
                  </div>
                  <button type="button" class="position-absolute position-sm-relative m-2 m-sm-0 top-0 end-0 btn btn-icon ms-sm-auto" data-bs-dismiss="alert">
                    <i class="bi bi-x fs-1 text-black"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="closeModal"></Button>
              <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="processing"></Button>
            </div>
          </div>
        </form>
      </div>
    </div>
  <CreateRightForm :id="id+'create_role'" @reloadDatatable="handleCreateRole" :hasParent="true" :parent="id"/>
  <CreateDepartmentForm
      :id="id+'create_department'"
      :hasParent="true"
      :parent="id"
      @reloadDepartments="handleCreatedDepartment" />
  <CreatePostForm :id="'kt_modal_'+id+'_post'" @postOffice="handleCreatedPost" :parent="id"/>
</template>

<script setup>
import ImageInput from "@/components/ImageInput.vue";
import {ref, defineEmits, defineProps, computed, watch,onMounted} from "vue";
import Select2 from "@/components/Select2.vue";
import Input from "@/components/Input.vue";
import CreateRightForm from '@/components/modals/right/Create.vue'
import CreateDepartmentForm from '@/components/department/Create.vue'
import {useStore} from "vuex";
import InputTel from "@/components/InputTel.vue";
import RequiredText from "@/components/RequiredText"
import Button from "@/components/Button"
import CreatePostForm from '@/components/Post/postModal.vue'

const store = useStore()
const emits = defineEmits(['afterUpdate', 'afterCreate'])
const props = defineProps({
  id: { type: String, required: true},
  isEdit: { type: Boolean, default: false},
  parent: String,
  user : {
    type: Object,
    default: () => ({
      gender: '',
      initials: '',
      lastname: '',
      firstname: '',
      email: '',
      phone_code: '',
      phone: '',
      role: null,
      active: true,
      office_id: '',
      society_id: '',
      avatar : null,
      avatar_url: null,
    })
  }
})

const processing = ref(false)
const formData = ref(props.user)
const initial_image = ref(null)

const roles = computed(() => store.getters['role/roles'])
const offices = computed(() => store.getters['offices/getOffices'])
const societiesOffices = computed(() => store.getters['offices/getOfficesBySocieties'])



const loadOffices = (societyId) => {
  if (societyId) {
    store.dispatch('offices/loadSocietyOffices', societyId);
  }
};

watch(() => formData.value.society_id, (newSocietyId) => {
  formData.value.office_id = formData.value.office_id ?? null;
  loadOffices(newSocietyId);
});

watch(() => props.user, (newValue) => {
  if(props.user.avatar_url){
    initial_image.value = props.user.avatar_url
  }
});

function openCreateRightModal ()
{
  $('#'+props.id).modal('toggle')
  $('#'+props.id+'create_role').modal('toggle')
}

function openCreateDepartmentModal () {
  $('#'+props.id).modal('toggle')
  $('#kt_modal_'+props.id+'create_department').modal('toggle')
}

function handleCreatedPost(id){
  formData.value.post_id = id
}

function openCreatePostModal () {
  $('#'+props.id).modal('toggle')
  $('#kt_modal_'+props.id+'_post').modal('toggle')
}

function closeModal(){
  if(props.parent){
    $('#'+props.parent).modal('toggle')
  }
  $('#'+props.id).modal('toggle')
}

function handleCreatedDepartment (id) {
  formData.value.department_id = id
}

function handleCreateRole (id) {
  formData.value.role = id
}

function initializeForm(){
  formData.value = {
    gender: '',
    initials: '',
    lastname: '',
    firstname: '',
    email: '',
    phone_code: '',
    phone: '',
    role: null,
    active: true,
    avatar_url: null,
    office_id: null,
    society_id : null,
  }
}

function submitForm () {
  props.isEdit ? updateUser() : createUser()
}

function updateUser() {
  processing.value = true

  let delete_image = formData.value.avatar_url && (formData.value.avatar instanceof File || formData.value.avatar == null) ? true : false
  formData.value.avatar = (formData.value.avatar instanceof File) ? formData.value.avatar : null

  store.dispatch('user/updateUser', {delete_image: delete_image ,...formData.value})
      .then(res => {
        loadData()
        closeModal()
        window.toastr['success'](i18n.global.t("notification.user_updated"))
        emits('afterUpdate')
      })
      .finally(() => processing.value = false)
}

function createUser() {
  processing.value = true
  store.dispatch('user/createUser', {delete_image: null ,...formData.value})
      .then(res => {
        loadData()
        closeModal()
        initializeForm()
        window.toastr['success'](i18n.global.t("notification.user_created"))
        emits('afterCreate', res?.data?.user?.id)
      })
      .finally(() => processing.value = false)
}

function loadData() {
  Promise.all([
    store.dispatch('role/loadRole'),
  ])
}

onMounted(() => {
  loadData()
});

</script>